import { Typography } from "@circle-react-shared/uikit/Typography";

interface TitleProps {
  prefix?: string;
  suffix?: string;
  title: string;
}

export const Title = ({ prefix, title, suffix }: TitleProps) => (
  <span className="inline-block whitespace-nowrap">
    {prefix && (
      <span className="pr-1">
        <Typography.LabelSm weight="normal">{prefix}</Typography.LabelSm>
      </span>
    )}
    <Typography.LabelMd weight="semibold">{title}</Typography.LabelMd>
    {suffix && (
      <span className="pl-1">
        <Typography.LabelSm weight="normal">{suffix}</Typography.LabelSm>
      </span>
    )}
  </span>
);
